"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TechnologyDemonstration = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var TechnologyDemonstration = (function (_super) {
    __extends(TechnologyDemonstration, _super);
    function TechnologyDemonstration() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.TECHNOLOGY_DEMONSTRATION,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.SPACE],
            cost: 5,
            metadata: {
                cardNumber: '204',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.cards(2);
                }),
                description: 'Draw two cards.',
            },
        }) || this;
    }
    TechnologyDemonstration.prototype.play = function (player) {
        player.drawCard(2);
        return undefined;
    };
    return TechnologyDemonstration;
}(Card_1.Card));
exports.TechnologyDemonstration = TechnologyDemonstration;
//# sourceMappingURL=TechnologyDemonstration.js.map